
import ActionTypes from "./ActionTypes";
import InteractionTypes from "./InteractionTypes";

const FeatureType = 'BookChat';

const BookChatEventTypes = {
	BOOKCHAT_LINK_CLICKED: {
		featureClick: {
			name: "linktobookchat"
		},
		interaction: {
			name: 'BookChat: NoveList - clicked',
			actionType: ActionTypes.P_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
}


export default BookChatEventTypes;



// WEBPACK FOOTER //
// ./src/data/types/LinkToBookChatEventTypes.js